import { HedgePositionStatus } from '@src/containers/Blotters/HedgePositionStatus';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { HedgePositionStatusPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function HedgePositionStatusPanel({ params, api }: LayoutPanelProps<HedgePositionStatusPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.PositionAutoHedgingBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="hedge-position-status-panel"
      >
        <HedgePositionStatus />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
